import createTaskType from '../../createTaskType';
import { cloneDeep, times } from "lodash";
import removePropertiesDeep from "@dyl/utils/removePropertiesDeep";
import PictureEditingEditor from "@dyl/task-types/A1/PictureEditing/Editor";

function Phase1Answers(index) {
    return times(3, (answerIndex) => ({
        is_correct_answer: answerIndex === 0,
        coordinates: {
            top: 0,
            left: 0
        },
        image_id: null
    }));
}

function Phase2Answers(index) {
    return times(3, (answerIndex) => ({
        is_correct_answer: answerIndex === 0,
        coordinates: {
            top: 0,
            left: 0
        },
    }));
}


export default createTaskType({
    id: 'picture_editing',
    label: 'Picture Editing',
    skill: 'listening',
    v2: true,
    hasRubric: true,

    backgroundImages: { count: 1 },

    createItemsTemplate: () => times(7, i => ({
        item_type: 'CHOICE',
        // Example only section
        is_example: i === 0,
        ...((i === 0 || i === 5) && { rubric_id: '' }),
        phase: i < 5 ? 'PHASE_1' : 'PHASE_TEXT',
        answers: i < 5 ? Phase1Answers(i) : Phase2Answers(i),
        ...(i >= 5 && { keys: [] }),
    })),
    editor: PictureEditingEditor,

    convertToUploadFormat(task, { isNew }) {
        task = cloneDeep(task);

        task.colors = null;

        task.items = task.items.map(x => {
            delete x.item_type;
            return x;
        })

        if (!isNew) {
            removePropertiesDeep(task, 'label');
        }

        return task;
    },
    rubric: {
        phaseCount: 1,  // Actually 2 but we use them interchangeably.
    },

    getKeys: (item) => {
        const correct_answer = item.answers.find(x => x.is_correct_answer);
        if (item.phase === 'PHASE_1') {
            return [`${correct_answer.label} (${correct_answer.coordinates.top}, ${correct_answer.coordinates.left}); Option ${correct_answer.label}-[${correct_answer.image_id}]`];
        } else {
            return [`${correct_answer.label} (${correct_answer.coordinates.top}, ${correct_answer.coordinates.left}); [${item.keys}]`];
        }
    }
});